<template>
  <ModuleContainer v-bind="bindModule">
    <template #btn>
      <div class="d-flex">
        <div v-if="helpText" class="tip-class button-container">
          {{ helpText }}
        </div>
        <MapControlMenuButton
          v-if="!drawingMode"
          icon="mdi-hammer-screwdriver"
          :tooltip="$t('map.measurement.title')"
        >
          <MapControlGroupButton row>
            <MapControlButton
              :disabled="disabled"
              icon="mdi-cog-outline"
              :tooltip="$t('actions.setting')"
              @click="isShowSetting = !isShowSetting"
            />
            <!-- <MapControlButton
          :color="drawingMode == 'point' ? 'primary' : null"
          :disabled="disabled"
          icon="mdi-map-marker-outline"
          :tooltip="$t('map.measurement.tools.point')"
          @click="onMeasurePoint()"
        /> -->
            <MapControlButton
              :color="drawingMode == 'distance' ? 'primary' : null"
              :disabled="disabled"
              icon="mdi-ruler"
              :tooltip="$t('map.measurement.tools.distance')"
              @click="onMeasureDistance()"
            />
            <MapControlButton
              :color="drawingMode == 'area' ? 'primary' : null"
              :disabled="disabled"
              icon="mdi-ruler-square-compass"
              :tooltip="$t('map.measurement.tools.area')"
              @click="onMeasureArea()"
            />
            <MapControlButton
              :color="drawingMode == 'azimuth' ? 'primary' : null"
              :disabled="disabled"
              icon="mdi-table-headers-eye"
              :tooltip="$t('map.measurement.tools.azimuth')"
              @click="onMeasureAzimuth()"
            />
            <MapControlButton
              v-if="geometry || markers.length > 0"
              :disabled="disabled"
              icon="mdi-delete"
              :tooltip="$t('actions.clear')"
              @click="onClear()"
            />
          </MapControlGroupButton>
        </MapControlMenuButton>
        <MapControlGroupButton v-show="drawingMode" row>
          <!-- <MapControlButton
            :disabled="disabled"
            icon="mdi-content-save-outline"
            :tooltip="$t('actions.save')"
            @click="onCancel()"
          /> -->
          <MapControlButton
            v-if="geometry || markers.length > 0"
            :disabled="disabled"
            icon="mdi-delete"
            :tooltip="$t('actions.clear')"
            @click="onClear()"
          />
          <MapControlButton
            v-else
            :disabled="disabled"
            icon="mdi-close"
            :tooltip="$t('actions.close')"
            @click="onClear()"
          />
        </MapControlGroupButton>
        
      </div>
    </template>
    <ShowGeometryControl
      color="#DA251D"
      disable-fill-bound
      :value="geometry"
      v-if="drawingMode"
    >
      <ShowDataControl
        :layers="drawingMode == 'azimuth' ? layerAzimuth : layerShows"
        :value="dataShow"
      />
    </ShowGeometryControl>
    <template #draggable="props">
      <DraggablePopup
        v-bind="props"
        :is-resizable="false"
        :show.sync="isShowSetting"
        :title="$t('actions.setting')"
      >
        <div class="pa-2">
          <v-row class="ma-0">
            <v-col cols="12">
              <v-select
                v-model="modelUnit.distance"
                dense
                hide-details
                :items="distanceUnits"
                :label="$t('map.measurement.field.unit-distance')"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="modelUnit.area"
                dense
                hide-details
                :items="areaUnits"
                :label="$t('map.measurement.field.unit-area')"
              ></v-select>
            </v-col>
          </v-row>
        </div>
      </DraggablePopup>
      <DraggablePopup
        v-bind="props"
        disable-close
        :height="260"
        :is-resizable="false"
        :show="drawingMode == 'azimuth'"
        :title="$t('map.measurement.tools.azimuth')"
        :width="250"
      >
        <v-row class="ma-0">
          <v-col class="d-flex align-center pb-0" cols="12">
            <div class="text-caption pr-2 blue-grey--text text--lighten-1"
              >Góc phương vị</div
            >
            <div class="text-h6 text-center flex-grow-1">
              {{ azimuthModel.azimuth }} °
            </div>
          </v-col>
          <v-col class="pb-0" cols="12">
            <div class="text-caption pr-2 blue-grey--text text--lighten-1">
              Điểm đầu
            </div>
            <div class="pa-2 text-center">
              {{ azimuthModel.startCoordinateText }}
            </div>
          </v-col>
          <v-col class="pb-0" cols="12">
            <div class="text-caption pr-2 blue-grey--text text--lighten-1">
              Điểm cuối
            </div>
            <div class="pa-2 text-center">
              {{ azimuthModel.lastCoordinateText }}
            </div>
          </v-col>
        </v-row>
      </DraggablePopup>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
import { Marker } from 'mapbox-gl'
import {
  area,
  length,
  centroid,
  lineString,
  polygon,
  bearing,
  bearingToAzimuth,
} from '@turf/turf'
import ShowGeometryControl from '@components/Map/modules/ShowControl/ShowGeometryControl.vue'
import ShowDataControl from '@components/Map/modules/ShowControl/ShowDataControl.vue'
import MapControlGroupButton from '@components/Map/control/MapControlGroupButton.vue'
import MapControlMenuButton from '@components/Map/control/MapControlMenuButton.vue'
import MapControlButton from '@components/Map/control/MapControlButton.vue'
import { formatNumber } from '@utils/Number'
import MapboxImageMixin from '@components/Map/mixins/MapboxImageMixin'
export default {
  components: {
    DraggablePopup,
    MapControlGroupButton,
    MapControlMenuButton,
    MapControlButton,
    ShowGeometryControl,
    ShowDataControl,
  },
  props: {
    disabled: Boolean,
    popUpPosition: {
      type: Object,
      default: () => ({
        top: 10,
        right: 49,
        width: '330px',
        height: '270px',
      }),
    },
    color: { type: String, default: '#DA251D' },
  },
  mixins: [ModuleMixin, MapboxImageMixin],
  data: (vm) => ({
    geometry: null,
    drawingMode: undefined,
    layerAzimuth: [
      {
        type: 'symbol',
        layout: {
          'icon-size': 0.08,
          'icon-rotate': {
            type: 'identity',
            property: 'rotation',
          },
          'icon-rotation-alignment': 'map',
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          // 'icon-ignore-placement': true,
          'icon-image': 'azimuth-arrow',
          visibility: 'visible',
        },
      },
    ],
    layerShows: [
      {
        type: 'circle',
        filter: ['==', '$type', 'Point'],
        paint: {
          'circle-radius': 4,
          'circle-color': vm.color,
          'circle-stroke-color': 'black',
          'circle-stroke-width': 0.5,
        },
      },
      {
        type: 'symbol',
        filter: ['==', '$type', 'Point'],
        layout: {
          'text-field': '{text}',
          'text-font': ['Roboto Medium'],
          'text-offset': [0, 2],
          'text-size': 14,
          'text-allow-overlap': true,
        },
        paint: {
          'text-color': '#000',
          'text-halo-blur': 1,
          'text-halo-color': 'rgba(255,255,255,0.75)',
          'text-halo-width': 1,
        },
      },
    ],
    dataShow: [],
    isShowSetting: false,
    coordinates: [],
    distanceUnits: ['meter', 'kilometer'].map((x) => ({
      text: vm.$t('map.measurement.unit.' + x),
      value: x,
    })),

    areaUnits: ['square-meter', 'hecta', 'square-kilometer'].map((x) => ({
      text: vm.$t('map.measurement.unit.' + x),
      value: x,
    })),
    modelUnit: { distance: 'kilometer', area: 'square-kilometer' },
    azimuthModel: {
      azimuth: 0,
      startCoordinateText: 'Cần chọn điểm đầu',
      lastCoordinateText: 'Cần chọn điểm cuối',
      startCoordinate: null,
      lastCoordinate: null,
    },
    helpText: '',
  }),
  created() {
    this.markers = []
  },
  computed: {},
  watch: {
    modelUnit: {
      handler(value) {
        if (this.geometry) {
          this.updateLabels()
        }
      },
      deep: true,
    },
  },

  methods: {
    onCancel() {
      this.map.getCanvas().classList.remove('cursor-crosshair')

      this.drawingMode = ''
      this.removeListenerMap('click', 'map-' + this._uid)
      this.removeListenerMap('contextmenu', 'map-' + this._uid)
      this.markers.forEach((marker) => {
        marker.setDraggable(false)
      })
      this.helpText = ''
    },
    onMapClick(event) {
      const newCoordinate = [event.lngLat.lng, event.lngLat.lat]
      const marker = this.bindMethodCreateMarker(
        newCoordinate,
        this.coordinates.length
      )
        .setLngLat(event.lngLat)
        .addTo(this.map)
      this.markers.push(marker)
      this.coordinates.push(newCoordinate)
      this.updateSource()
      this.updateLabels()
      marker.on('drag', () => {
        if (!this.drawingMode) return
        const index = this.markers.indexOf(marker)
        const lngLat = marker.getLngLat()
        this.coordinates[index] = [lngLat.lng, lngLat.lat]
        this.updateSource()
        this.updateLabels()
      })
    },
    updateSource() {
      if (!this.drawingMode) {
        this.geometry = null
        return
      }
      let feature = this.bindMethodGetFeature(this.coordinates)
      this.geometry = feature ? feature.geometry : null
    },
    updateLabels() {
      if (!this.bindMethodUpdateLabel) return
      this.bindMethodUpdateLabel(this.coordinates)
    },
    async onInit() {
      let url = '/static/img/arrow.png'
      await this.createMapboxImageUrl('azimuth-arrow', url)
    },
    onDestroy() {
      this.onClear()
    },
    onMeasurePoint() {
      if (this.drawingMode == 'point') {
        this.onClear()
        return
      }
      this.onStartMeasure('point')
      this.bindMethodGetFeature = (coordinates) => null
      this.bindMethodCreateMarker = (coordinate) => {
        this.markers.forEach((marker) => {
          marker.remove()
        })
        this.markers = []
        this.coordinates = []
        return getMarkerNode({ color: this.color })
      }

      this.bindMethodUpdateLabel = (coordinates) => {
        this.dataShow = coordinates.map((x, i, array) => {
          let point = this.formatCoordinates(x)
          return {
            type: 'Feature',
            properties: {
              text: `${point[0].toFixed(3)}, ${point[1].toFixed(3)}`,
            },
            geometry: { type: 'Point', coordinates: x },
          }
        })
      }
    },
    onMeasureDistance() {
      if (this.drawingMode == 'distance') {
        this.onClear()
        return
      }
      this.onStartMeasure('distance')
      this.bindMethodCreateMarker = (coordinate) =>
        getMarkerNode({ color: this.color })
      this.bindMethodGetFeature = (coordinates) =>
        coordinates.length > 1 ? lineString(coordinates) : null
      this.bindMethodUpdateLabel = (coordinates) => {
        if (coordinates.length < 2) return
        this.dataShow = coordinates.map((x, i, array) => {
          return {
            type: 'Feature',
            properties: {
              text: this.formatDistanceText(
                i < 1 ? 0 : length(lineString(array.slice(0, i + 1)))
              ),
            },
            geometry: { type: 'Point', coordinates: x },
          }
        })
      }
    },
    onMeasureArea() {
      if (this.drawingMode == 'area') {
        this.onClear()
        return
      }
      this.onStartMeasure('area')
      this.bindMethodCreateMarker = (coordinate) =>
        getMarkerNode({ color: this.color })
      this.bindMethodGetFeature = (coordinates) => {
        return coordinates.length > 2
          ? polygon([[...coordinates, coordinates[0]]])
          : null
      }
      this.bindMethodUpdateLabel = (coordinates) => {
        if (coordinates.length < 3) return
        this.dataShow = [
          centroid(this.geometry, {
            text: this.formatAreaText(area(this.geometry)),
          }),
        ]
      }
    },
    onMeasureAzimuth() {
      if (this.drawingMode == 'azimuth') {
        this.onClear()
        return
      }
      this.onStartMeasure('azimuth')

      this.bindMethodCreateMarker = (coordinate) => {
        return getMarkerNode({ color: this.color })
      }
      this.bindMethodGetFeature = (coordinates) => {
        if (coordinates.length < 2) return
        if (this.markers.length > 2 && this.markers[0]) {
          this.markers[0].remove()
          this.markers.shift()
        }
        let end = coordinates[coordinates.length - 1]
        let start = coordinates[coordinates.length - 2]
        this.coordinates = [start, end]

        return coordinates.length > 1 ? lineString([start, end]) : null
      }
      this.bindMethodUpdateLabel = (coordinates) => {
        if (coordinates.length == 1) {
          let start = coordinates[0]
          let startpoint = this.formatCoordinates(start)
          this.azimuthModel.startCoordinateText = `${startpoint[0].toFixed(
            3
          )}, ${startpoint[1].toFixed(3)}`
          this.azimuthModel.startCoordinate = {
            type: 'Point',
            coordinates: start,
          }
          return
        }
        if (coordinates.length < 2) return

        let end = coordinates[coordinates.length - 1]
        let start = coordinates[coordinates.length - 2]
        const lineBearing = bearing(start, end)
        this.azimuthModel.azimuth = bearingToAzimuth(lineBearing).toFixed(3)

        let startpoint = this.formatCoordinates(start)
        this.azimuthModel.startCoordinate = {
          type: 'Point',
          coordinates: start,
        }
        this.azimuthModel.startCoordinateText = `${startpoint[0].toFixed(
          3
        )}, ${startpoint[1].toFixed(3)}`
        let endpoint = this.formatCoordinates(end)
        this.azimuthModel.lastCoordinate = { type: 'Point', coordinates: end }
        this.azimuthModel.lastCoordinateText = `${endpoint[0].toFixed(
          3
        )}, ${endpoint[1].toFixed(3)}`
        this.dataShow = [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: end,
            },
            properties: {
              rotation: lineBearing - 90,
            },
          },
        ]
      }
      this.bindMethodClear = () => {
        this.azimuthModel = {
          azimuth: 0,
          startCoordinateText: 'Cần chọn điểm đầu',
          lastCoordinateText: 'Cần chọn điểm cuối',
          startCoordinate: null,
          lastCoordinate: null,
        }
      }
    },
    onStartMeasure(type) {
      this.onClear()
      this.map.getCanvas().classList.add('cursor-crosshair')
      this.addListenerMap(
        'click',
        'map-' + this._uid,
        this.onMapClick.bind(this)
      )

      this.addListenerMap(
        'contextmenu',
        'map-' + this._uid,
        this.onMapRightClick.bind(this)
      )
      this.helpText =
        'Nhấp chuột trái để chọn điểm trên bản đồ, chuột phải để dừng'
      this.drawingMode = type
    },
    onMapRightClick(e) {
      e.originalEvent.preventDefault()
      e.originalEvent.stopPropagation()
      this.onClear()
    },
    formatAreaText(value = 0) {
      switch (this.modelUnit.area) {
        case 'square-meter':
          return `${formatNumber(value)} m²`
        case 'hecta':
          return `${formatNumber(value / 10000)} ha`
        case 'square-kilometer':
          return `${formatNumber(value / 1000000)} km²`
        default:
          throw new Error('Not support unit ' + this.modelUnit.area)
      }
    },
    formatDistanceText(value = 0) {
      switch (this.modelUnit.distance) {
        case 'meter':
          return `${formatNumber(value / 1000)} m`
        case 'kilometer':
          return `${formatNumber(value)} km`
        default:
          throw new Error('Not support unit ' + this.modelUnit.distance)
      }
    },
    onClear() {
      this.onCancel()
      this.markers.forEach((m) => m.remove())
      this.geometry = null
      this.bindMethodCreateMarker = null
      this.bindMethodGetFeature = null
      this.bindMethodUpdateLabel = null
      this.markers = []
      this.coordinates = []
      this.dataShow = []
      if (this.bindMethodClear) {
        this.bindMethodClear()
      }
      this.bindMethodClear = null
    },
    updateAzimuthModel() {
      if (this.azimuthModel.startCoordinate) {
        let start = this.azimuthModel.startCoordinate.coordinates
        let startpoint = this.formatCoordinates(start)
        this.azimuthModel.startCoordinateText = `${startpoint[0].toFixed(
          3
        )}, ${startpoint[1].toFixed(3)}`
      } else {
        this.azimuthModel.startCoordinateText = 'Cần chọn điểm đầu'
      }
      if (this.azimuthModel.lastCoordinate) {
        let end = this.azimuthModel.lastCoordinate.coordinates
        let endpoint = this.formatCoordinates(end)

        this.azimuthModel.lastCoordinateText = `${endpoint[0].toFixed(
          3
        )}, ${endpoint[1].toFixed(3)}`
      } else {
        this.azimuthModel.lastCoordinateText = 'Cần chọn điểm cuối'
      }
      if (
        this.azimuthModel.startCoordinate &&
        this.azimuthModel.lastCoordinate
      ) {
        const lineBearing = bearing(
          this.azimuthModel.startCoordinate.coordinates,
          this.azimuthModel.lastCoordinate.coordinates
        )
        this.azimuthModel.azimuth = bearingToAzimuth(lineBearing).toFixed(3)
        this.dataShow = [
          {
            type: 'Feature',
            geometry: this.azimuthModel.lastCoordinate,
            properties: {
              rotation: lineBearing - 90,
            },
          },
        ]
      }
    },
  },
}
function getMarkerNode({ color } = {}) {
  const node = document.createElement('div')
  node.style.width = '12px'
  node.style.height = '12px'
  node.style.borderRadius = '50%'
  node.style.background = '#fff'
  node.style.boxSizing = 'border-box'
  node.style.border = `2px solid ${color}`
  node.style.cursor = 'pointer'
  return new Marker({
    element: node,
    draggable: true,
  })
}
</script>

<style>
.tip-class {
  border: 1px #b6aeae solid;
  width: 250px;
  line-height: 30px;
  padding-left: 10px;
  background-color: #00000088;
  color: #fff;
  border-radius: 6px 6px 6px 0px;
  pointer-events: none;
}
.left-container {
  right: 60px;
}
.right-container {
  right: 60px;
}
</style>
